/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
import constants from "../constants";

const {
  // UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID_STORE,
  UPDATE_CLIENT_RESERVATIONS_STORE,
  UPSERT_CLIENT_RESERVATION_STORE,
  REMOVE_CLIENT_RESERVATION_STORE,
} = constants;

const initialState = {
  clientReservations: {},
  // clientReservationsByClientId: {},
};

export default (state = initialState, action) => {
  if (!action) return state;

  const { type } = action;

  switch (type) {
    // case UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID_STORE:
    //   return {
    //     ...state,
    //     clientReservationsByClientId: action.data || {},
    //   };

    case UPDATE_CLIENT_RESERVATIONS_STORE:
      return {
        ...state,
        clientReservations: action.data || {},
      };

    case UPSERT_CLIENT_RESERVATION_STORE: {
      const clientReservation = action?.data;
      const uid = clientReservation?.uid;
      const clientId = clientReservation?.clientId;

      if (!uid) return state;

      return {
        ...state,
        clientReservations: {
          ...state.clientReservations,
          [clientId]: {
            ...state.clientReservations[clientId],
            [uid]: clientReservation,
          },
        },
      };
    }

    case REMOVE_CLIENT_RESERVATION_STORE: {
      const uid = action?.removedId;
      const clientId = action?.clientId;
      if (!uid) return state;

      const nextClientReservations = { ...state.clientReservations };
      delete nextClientReservations[clientId]?.[uid];

      return {
        ...state,
        clientReservations: nextClientReservations,
      };
    }

    default:
      return state;
  }
};
